import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useOutOfPocketSubStep from "./hooks/useOutOfPocketSubStep";

const OutOfPocketSubStep = () => {
  const subStepData = useOutOfPocketSubStep();

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={subStepData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {subStepData.screen_title} -{" "}
          <span className="heading-cod">{subStepData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={subStepData.formFields}
        dropdownValues={subStepData.dropdownValues}
        paramsData={subStepData.paramsData}
        updataParamData={subStepData.updateParamData}
      />
      <ButtonsSection ctaButtons={subStepData.ctaButtons} />
      <DisplayTable
        data={subStepData.data}
        parmKey={subStepData.parmKey}
        menuOptions={subStepData.menuOptions}
        tableHeaders={subStepData.columnDef}
        setRowData={subStepData.setRowData}
        selectedPriceSchedules={subStepData.selectedRows}
        setSelectedPriceSchedules={subStepData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={subStepData.first}
          rows={subStepData.rows}
          totalRecords={subStepData.totalRecords}
          currentPage={subStepData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={subStepData.onPageChange}
        />
      </div>
      {subStepData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={subStepData.isConfirmationModalOpen}
          onRequestClose={subStepData.closeConfirmationModal}
          onBack={subStepData.closeConfirmationModal}
          onSave={subStepData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={subStepData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default OutOfPocketSubStep;
